import { createContext, useContext } from "react";

/** @type {import("../../../config/CsvExportConfigs.js").CsvExportConfig} */
const defaultExportConfig = {
  filename: "export",
  exportAll: true,
};

export const AsyncDataGridExportContext = createContext({
  rows: [],
  loading: false,
  exportConfig: defaultExportConfig,
  gridColumns: [],
  isServerMode: false,
  hideExport: false,
});

/**
 * @returns {{
 *   rows: unknown[],
 *   loading: boolean,
 *   exportConfig: import("../../../config/CsvExportConfigs.js").CsvExportConfig,
 *   gridColumns: import("@mui/x-data-grid").GridColDef[],
 *   isServerMode: boolean,
 *   hideExport: boolean,
 * }}
 */
export function useAsyncDataGridExport() {
  return useContext(AsyncDataGridExportContext);
}
